import React from "react";

import { useSetPropertyBillableUnits } from "manager/hooks/api";
import { Property } from "manager/interfaces/api";
import { NOTIFICATIONS } from "shared/config/constants";
import useModal from "shared/hooks/useModal";
import { openNotification } from "shared/utils/ui";

import { expectedBillingSnapshot } from "./billingDisplay";
import EditBillableUnitsModal from "./EditBillableUnitsModal";

interface EditBillableUnitsModalContainerProps {
  property: Property;
  onSuccess?: () => void;
}

const EditBillableUnitsModalContainer = ({
  property,
  onSuccess,
}: EditBillableUnitsModalContainerProps) => {
  const { closeActiveModalDialog } = useModal();
  const { setPropertyBillableUnits, isSaving } = useSetPropertyBillableUnits();

  const submit = async ({ resetToAuto, billableUnits }) => {
    await setPropertyBillableUnits({
      propertyId: property.id,
      payload: {
        resetToAuto,
        ...(resetToAuto ? {} : { billableUnits }),
        ...expectedBillingSnapshot(property),
      },
    });
    openNotification(
      `Updated billable units for ${property.name}.`,
      NOTIFICATIONS.info
    );
    closeActiveModalDialog();
    onSuccess?.();
  };

  return (
    <EditBillableUnitsModal
      property={property}
      submit={submit}
      submitting={isSaving}
    />
  );
};

export default EditBillableUnitsModalContainer;
